/**
 * 利用停止の範囲（`mode`）。
 *
 * **語彙はサーバーの `services/org-suspension.ts` の `SUSPEND_MODES` が正**で、
 * DB の CHECK 制約（0030）とも 1 対 1。画面側で別の名前を作らないこと。
 *
 * 以前ここは `login_only` / `delivery_stop` / `full` という独自の 3 値を送っており、
 * サーバの zod が非 strict だった時代は**どれを選んでも送信停止**になっていた
 * （`.strict()` になった後は 400 で必ず失敗する）。停止範囲の取り違えは
 * 「全面停止したつもりで受信が流れ続ける」という形で表に出るので、
 * 選択肢は 1 か所に置いて画面から複製させない。
 */
export const SUSPEND_MODES = ['outbound', 'delivery', 'full'] as const;
export type SuspendMode = (typeof SUSPEND_MODES)[number];

/** 画面に出す日本語。サーバーの `SUSPEND_MODE_LABEL` と同じ意味に揃える。 */
export const SUSPEND_MODE_LABEL: Record<SuspendMode, string> = {
  outbound: 'メールの送信を停止（受信とログインは継続）',
  delivery: 'メールの送受信を停止（ログインは継続）',
  full: '全面停止（送受信とコントロールパネルの利用を停止）',
};

export const SUSPEND_MODE_OPTIONS: Array<{ value: SuspendMode; label: string }> = SUSPEND_MODES.map(
  (value) => ({ value, label: SUSPEND_MODE_LABEL[value] }),
);
